$(document).ready(function () {
  $('.slider_big .header-img .carousel-caption').each(function () {
    var $carouselCaption = $(this);

    // Handling headline1
    var $headline1 = $carouselCaption.find('.headline1');
    var $headline1Wrapper;
    if ($headline1.length) {
      $headline1Wrapper = $('<div class="headline1-wrapper"></div>');
      $headline1.before($headline1Wrapper);
      $headline1Wrapper.append($headline1);
    }

    // Handling headline2, .text-wrapper, and p
    var $headline2 = $carouselCaption.find('.headline2');
    var $textWrapper = $carouselCaption.find('.text-wrapper');
    var $paragraphs = $carouselCaption.find('.btn');

    if ($headline2.length || $textWrapper.length || $paragraphs.length) {
      var $sliderContentWrapper = $('<div class="slider_content-wrapper"></div>');

      // Insert the wrapper after the headline1 wrapper if it exists, otherwise at the beginning
      if ($headline1Wrapper) {
        $headline1Wrapper.after($sliderContentWrapper);
      } else {
        $carouselCaption.prepend($sliderContentWrapper);
      }

      if ($headline2.length) {
        $sliderContentWrapper.append($headline2);
      }

      if ($textWrapper.length) {
        $sliderContentWrapper.append($textWrapper);
      }

      if ($paragraphs.length) {
        $paragraphs.each(function () {
          $sliderContentWrapper.append($(this));
        });
      }
    }
  });

  function adjustPadding() {
    if ($(window).width() > 991) {
      var teaserHeight = $('.icon-teaser-wrapper').height();
      $('.slider_big .caption-wrapper').each(function () {
        $(this).css('padding-bottom', teaserHeight);
      });
    } else {
      $('.slider_big .caption-wrapper').css('padding-bottom', '0');
    }
  }

  adjustPadding();
  $(window).resize(function () {
    adjustPadding();
  });
});

function setBottomValue() {
  var heightOfIconTeaserWrapper = $(".icon-teaser-wrapper").height();
  var bottomValue = heightOfIconTeaserWrapper + 30;
  $(".slider_big .amphi-slideshow .owl-dots").css("bottom", bottomValue + "px");
}

function setBottomValueForSmallViewport() {
  $(".slider_big .amphi-slideshow .owl-dots").css("bottom", "30px");
}

$(window).on("load resize", function () {
  if ($(window).width() > 992) {
    setBottomValue();
    $(window).resize(function () {
      setBottomValue();
    });
  } else {
    setBottomValueForSmallViewport();
    $(window).resize(function () {
      setBottomValueForSmallViewport();
    });
  }
});

$(document).ready(function () {
  $(function () {
    $('.module-style__truncate-content-individual .text-wrapper').not('.caption .text-wrapper').each(function () {
      var $textWrapper = $(this);
      var originalContent = $textWrapper.html(); // Originalinhalt speichern
      $textWrapper.data('original-content', originalContent);

      function bindToggle($el) {
        $el.find('.toggle').off('click').on('click', function (e) {
          e.preventDefault();
          var $wrapper = $(this).closest('.text-wrapper');
          if ($wrapper.hasClass('expanded')) {
            // Zuklappen
            $wrapper.removeClass('expanded');
            $wrapper.html($wrapper.data('original-content'));
            applyDotdotdot($wrapper); // Dotdotdot neu anwenden
          } else {
            // Ausklappen
            $wrapper.addClass('expanded');
            $wrapper.html($wrapper.data('original-content') + '<a class="toggle" href="#">[<span class="amphiicon amphiicon-angle-up amphiicon-solid amphiicon-1x"></span>]</a>');
            bindToggle($wrapper); // Toggle-Link neu binden
          }
        });
      }

      function applyDotdotdot($el) {
        $el.dotdotdot({
          watch: 'window',
          height: parseFloat($el.css('line-height')) * 4,
          after: 'a.toggle',
          callback: function (isTruncated) {
            if (isTruncated) {
              if ($el.find('.toggle').length === 0) {
                $el.append('<a class="toggle" href="#">[...]</a>');
              }
              bindToggle($el); // Initial binden
            }
          }
        });
      }

      applyDotdotdot($textWrapper); // Initial anwenden
    });
  });
});